import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]

import BranchInterface from '@/interfaces/BranchInterface';
import {
  computed, nextTick, onBeforeUnmount, onMounted, onUpdated, ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCalculatorBranchIcon',
  props: {
    branch: {},
    selected: { type: Boolean },
    deselected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const branchLabel = ref<InstanceType<typeof HTMLElement>>();
const labelVariables = ref<Record<string, string>>({});
const cssVariables = computed(() => ({
  ...labelVariables.value,
  '--branch-color': props.branch.color,
}));

const isVisible = () => !!(branchLabel.value?.offsetWidth || branchLabel.value?.offsetHeight || branchLabel.value?.getClientRects().length);
const setCssVariables = async () => {
  if (branchLabel.value === undefined) return;
  if (!('style' in (branchLabel.value || {}))) return;

  if (!isVisible()) {
    await nextTick(setCssVariables);
    return;
  }

  branchLabel.value.style.setProperty('transition', 'none');
  branchLabel.value.style.setProperty('width', 'auto');
  branchLabel.value.classList.add('check-size');

  labelVariables.value['--label-width'] = `${branchLabel.value.offsetWidth}px`;

  branchLabel.value.classList.remove('check-size');
  branchLabel.value.style.removeProperty('width');
  branchLabel.value.style.removeProperty('transition');
};

onUpdated(() => {
  if (isVisible()) return;

  setCssVariables();
});

onMounted(() => {
  window.addEventListener('resize', setCssVariables);
  setCssVariables();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setCssVariables);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-calculator__branch-icon", {
        selected: _ctx.selected,
        deselected: _ctx.deselected,
      }]),
    style: _normalizeStyle(cssVariables.value)
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        src: _ctx.branch.image?.url,
        alt: `Icon ${_ctx.branch.name}`
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        ref_key: "branchLabel",
        ref: branchLabel,
        class: "base-calculator__branch-icon__label",
        innerHTML: _ctx.branch.name
      }, null, 8, _hoisted_2)
    ])
  ], 6))
}
}

})